module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.e8bdc1b7.jpg";